import Workload from './workload';

export default class DaemonSet extends Workload {
}
